import { Box, Chip } from "@mui/material";
import { EDynamicColumnType, IDynamicColumnFilter, ISelectOption } from "Interfaces/Utils";

interface IAppliedFiltersProps {
  filters: IDynamicColumnFilter[];
  filterValues: Record<string, any>;
  handleRemoveFilter: (field: string) => void;
};


/**
 * Component to view applied filters as tags
 * 
 * @param { IDynamicColumnFilter[] } filters - 
 * @param { Record<string, any> } filterValues 
 * @param { (field: string) => void } handleRemoveFilter 
 * @returns 
 */

export const AppliedFilters = (props: IAppliedFiltersProps) => {

  const { filters, filterValues, handleRemoveFilter } = props;

  const getValueLabel = (value: string, filter: IDynamicColumnFilter | undefined) => {

    if (!filter) return "";

    let castedValue: string = value;

    if (filter.type === EDynamicColumnType.SELECT && filter.values){
      castedValue = getLabelFromValue(filter.values, value);
    }
    else if (filter.type === EDynamicColumnType.DATE) {
      const date = new Date(value);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();   
    
      castedValue = `${day}/${month}/${year}`;
    }

    return `${filter.label}: ${castedValue}`
  };

  const getLabelFromValue = (arr: ISelectOption[], targetValue: string): string => {
    const foundObj = arr.find(obj => obj.value === targetValue);
    return String(foundObj?.label);
  }

  return (
    <Box display={"flex"} gap={"5px"}>
      {
        Object.entries(filterValues).map(([field, row]) => {

          const filter = filters.find((filter) => filter.field === field);

          const label = getValueLabel(row?.value, filter);

          if (row?.value !== '' && row?.value !== null) {
            return (
              <Chip
                key={field}
                label={label}
                onDelete={() => handleRemoveFilter(field)}
                color="primary"
                variant="outlined"
              />
            );
          }
          return null;
        }).filter(chip => chip !== null)
      }
    </Box>
  )
};